
export const ContractOptionMask = {
    AuthCall800: 1,
    AuthCall499: 1 << 1,
    AuthSMS: 1<<2,
    AuthPIN: 1<<3,
    AuthMobileID: 1<<4,
    AuthESIA: 1<<5,
    AuthVoip: 1<<6,
    AuthExternalAPI: 1<<7,

    UnknownDevice: 1<<10,

    UseBillingAuthMeta: 1<<11,
    Lock: 1<<12,
    MacAuth: 1<<13,
    ForceIdentity: 1<<14,
    CustomLanding: 1<<15,
    QuotaLimit: 1<<16,
    SocialNet: 1<<17,

    ShowAd: 1<<18,
    ShowPolls: 1<<19,

    SocialNetVk: 1<<23,
    SocialNetOk: 1<<24,
    SocialNetMailru: 1<<26,
    SocialNetYandex: 1<<27,
    SocialNetEmailShare: 1<<28,
    SocialNetCanSkip: 1<<29,
    SocialNetSkipSecure: 1<<30,
}

export const CheckOptionON = (data, option) => {
    if (data&option) {return true}
    return false
}

export const checkEmptyAuthMeta = (data) => {
    if (data&(~511) === data) {return true}
    return false
}

export const authName = (opts) => {
    const res = ""
    if (opts&ContractOptionMask.UseBillingAuthMeta ) {return "По биллингу"}
    if (opts&ContractOptionMask.AuthSMS) {res += "SMS/"}
    if (opts&ContractOptionMask.AuthCall499) {res += "CALL/"}
    if (opts&ContractOptionMask.AuthCall800) {res += "CALL800/"}
    if (opts&ContractOptionMask.AuthPIN) {res += "PIN/"}
    if (opts&ContractOptionMask.AuthESIA) {res += "ESIA/"}
    if (opts&ContractOptionMask.AuthMobileID) {res += "PUSH/"}
    if (opts&ContractOptionMask.AuthVoip) {res += "VOIP/"}
    if (opts&ContractOptionMask.AuthExternalAPI) {res += "API/"}
    return res.slice(0, -1)
}